import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export type SafetyPlanIconProps = {
  size?: number | string
  fillColor?: string
}

export const SafetyPlanIcon: FunctionComponent<SafetyPlanIconProps> = ({ size = 24, fillColor }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={tID('SafetyPlanIcon')}>
      <Path
        d='M19.2588 21.0288V22.5288H4.74219V21.0288H19.2588ZM20.0088 20.2788V3.72217C20.0088 3.30795 19.673 2.97217 19.2588 2.97217H4.74219C4.32797 2.97217 3.99219 3.30796 3.99219 3.72217V20.2788C3.99219 20.693 4.32797 21.0288 4.74219 21.0288V22.5288L4.51172 22.5171C3.37736 22.4017 2.49219 21.4436 2.49219 20.2788V3.72217C2.49219 2.55734 3.37735 1.59931 4.51172 1.48389L4.74219 1.47217H19.2588C20.5014 1.47217 21.5088 2.47953 21.5088 3.72217V20.2788C21.5088 21.5214 20.5014 22.5288 19.2588 22.5288V21.0288C19.673 21.0288 20.0088 20.693 20.0088 20.2788Z'
        fill={fill}
      />
      <Path
        d='M18.0923 14.7114C18.5065 14.7114 18.8423 15.0472 18.8423 15.4614C18.8423 15.8756 18.5065 16.2114 18.0923 16.2114H6.51318C6.09897 16.2114 5.76318 15.8756 5.76318 15.4614C5.76318 15.0472 6.09897 14.7114 6.51318 14.7114H18.0923Z'
        fill={fill}
      />
      <Path
        d='M13.7446 17.2822C14.1588 17.2822 14.4946 17.618 14.4946 18.0322C14.4946 18.4464 14.1588 18.7822 13.7446 18.7822H6.51318C6.09897 18.7822 5.76318 18.4464 5.76318 18.0322C5.76318 17.618 6.09897 17.2822 6.51318 17.2822H13.7446Z'
        fill={fill}
      />
      <Path
        d='M15 6.61608C13.5001 6.22709 12.7502 5.88911 12.0062 5.50012C11.2502 5.88911 10.5012 6.2271 9.00021 6.66709C9.00021 7.06508 9.00021 8.19602 9.00021 8.61101C9.00021 10.9439 10.8751 12.1109 12.0001 12.4999C13.1251 12.1109 15 10.9439 15 8.61101C15 8.18202 15 7.03407 15 6.61608Z'
        stroke={fill}
        strokeWidth={1.5}
        strokeLinejoin='round'
      />
    </Svg>
  )
}
